import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaSpinner } from "react-icons/fa"; // Default spinner icon
import PropTypes from "prop-types";

const FullPageLoader = ({ text = "Loading...", theme = "dark", icon }) => {
  const isDark = theme === "dark";

  return (
    <AnimatePresence>
      <motion.div
        key="loader"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className={`position-fixed top-0 start-0 w-100 h-100 bg-${isDark ? "dark" : "light"} bg-opacity-75 d-flex justify-content-center align-items-center`}
        style={{ zIndex: 9999 }}
      >
        <div className={`text-center ${isDark ? "text-light" : "text-dark"}`}>
          <div className="mb-3" style={{ fontSize: "2.5rem" }}>
            {icon || <FaSpinner className="spinner-border-spin text-warning" />}
          </div>
          <div className="fs-5 fw-semibold">{text}</div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

FullPageLoader.propTypes = {
  text: PropTypes.string,
  theme: PropTypes.oneOf(["dark", "light"]),
  icon: PropTypes.node,
};

export default FullPageLoader;
